const typography = {
  
};

export default typography;
